import { render } from "./NewEmployeesAddAccounts.vue?vue&type=template&id=4941b2a6&scoped=true&ts=true"
import script from "./NewEmployeesAddAccounts.vue?vue&type=script&lang=ts"
export * from "./NewEmployeesAddAccounts.vue?vue&type=script&lang=ts"

import "./NewEmployeesAddAccounts.vue?vue&type=style&index=0&id=4941b2a6&lang=scss&scoped=true"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4941b2a6"]])

export default __exports__